import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope,$translate, $state, $q, $filter, AccountService, UserService, ModalService, ViewModelService, CountrySpecificPSA) => {
    const ctrl = Object.create(BaseCtrl);
    let countryWatchPSA;
    ctrl.init = () => {
        initialiseScopeVariables();
        ctrl.shouldShowEditContactButton();
        $scope.lists = [
            { 'vl': "mail", checked: false },
            { 'vl': "phone", checked: false },
            { 'vl': "sms", checked: false },
            { 'vl': "bypost", checked: false },
        ];
        $scope.accountDetail = {
            accountHolder: {},
        };
        const TRANSLATION_KEYS = {
            mail: 'psa.gateway.puw.views.new-quote-account-contact.Email',
            phone: 'psa.gateway.puw.views.new-quote-account-contact.Phone',
            sms: 'psa.gateway.puw.views.new-quote-account-contact.sms',
            bypost: 'psa.gateway.puw.views.new-quote-account-contact.post'
        };

         /**
             * Get the translation for the contactInfo(added as part of client consent)
             * @param {String} contactKey
             * @returns {String}
             */
          $scope.getContactInfoTranslation = (contactKey) => {
            const translationKey = TRANSLATION_KEYS[contactKey];
            let returnString = '';
            if (translationKey) {
                returnString = $translate.instant(translationKey);
            }
            return returnString;
        };
        $scope.EmailAttempt = 0;
    };

    /* Private Functions*/
    function initialiseScopeVariables() {
        $scope.isEditingContactDetails = false;
        $scope.hideFields = ['AddressLine2', 'AddressLine3']; // PSA
        $scope.CountrySpecificPSA = CountrySpecificPSA;
    }

    ctrl.findAccount = (accountNumber) => {
        if (angular.isDefined(accountNumber) && accountNumber.length > 0) {
            const findAccountPromise = AccountService.getAccountDetails(accountNumber);
            $scope.findAccountPromise = findAccountPromise;

            $q.when(findAccountPromise, (account) => {
                if (account.accountHolder) {
                    $scope.lists.forEach(function (list) {
                        account.accountHolder.contactsInfoData.forEach(function (i) {
                            if (list.vl === i) {
                                list.checked = true;
                            }
                        });
                         //Link 1
                        $scope.accountInfoCopyView.contactsInfoData.value =  account.accountHolder.contactsInfoData;
                    })
                } else {
                    ModalService.showError('gateway.views.modal.Error', 'gateway.views.new-quote.error.findAccount.account.type');
                    window.history.back();
                }
            }, () => {
                const msg = $translate('gateway.views.new-quote.error.findAccount.noaccount', {
                    accountNumber
                });
                ModalService.showError('gateway.views.modal.Error', msg);
                $state.go('newQuoteSearch');
            });
        }
    };
    function getUpdatedAccountContactDetails() {
        const updatedAccount = {};
        const accountHolder = {};
        updatedAccount.accountNumber = $scope.accountInfoCopy.accountNumber;

        if ($scope.accountInfoCopy.subtype === 'Person') {
            accountHolder.contactName = $scope.accountInfoCopy.contactName;
            accountHolder.subtype = 'Person';
            accountHolder.prefix = $scope.accountInfoCopy.prefix;
            accountHolder.firstName = $scope.accountInfoCopy.firstName;
            accountHolder.lastName = $scope.accountInfoCopy.lastName;
            accountHolder.primaryAddress = $scope.accountInfoCopy.primaryAddress;
            accountHolder.contactsInfoData = $scope.accountInfoCopy.contactsInfoData;
            // Link-1
            $scope.accountInfoCopy.contactsInfoData = [];
            $scope.lists.forEach(function (list) {
                if(list.checked == true ) {
                     $scope.accountInfoCopy.contactsInfoData.push(list.vl)
                }
            });
            //UCWPRODENG-834
            accountHolder.contactsInfoData = $scope.accountInfoCopy.contactsInfoData;
            if ($scope.accountInfoCopy.primaryPhoneType) {
                accountHolder.primaryPhoneType = $scope.accountInfoCopy.primaryPhoneType;
            } else if ($scope.accountInfoCopy.homeNumber) {
                accountHolder.primaryPhoneType = 'home';
            }

            accountHolder.workNumber = ($scope.accountInfoCopy.workNumber) ? $scope.accountInfoCopy.workNumber : null;
            accountHolder.homeNumber = ($scope.accountInfoCopy.homeNumber) ? $scope.accountInfoCopy.homeNumber : null;
            accountHolder.cellNumber = ($scope.accountInfoCopy.cellNumber) ? $scope.accountInfoCopy.cellNumber : null;
            accountHolder.emailAddress1 = ($scope.accountInfoCopy.emailAddress1) ? $scope.accountInfoCopy.emailAddress1 : null;


            updatedAccount.accountHolder = accountHolder;
        } else if ($scope.accountInfoCopy.subtype === 'Company') {
            accountHolder.contactName = $scope.accountInfoCopy.contactName;
            accountHolder.subtype = 'Company';
            accountHolder.primaryAddress = $scope.accountInfoCopy.primaryAddress;
            accountHolder.contactsInfoData = $scope.accountInfoCopy.contactsInfoData;
            accountHolder.primaryPhoneType = $scope.accountInfoCopy.primaryPhoneType ? $scope.accountInfoCopy.primaryPhoneType : 'work';
            accountHolder.workNumber = ($scope.accountInfoCopy.workNumber) ? $scope.accountInfoCopy.workNumber : null;
            accountHolder.homeNumber = ($scope.accountInfoCopy.homeNumber) ? $scope.accountInfoCopy.homeNumber : null;
            accountHolder.cellNumber = ($scope.accountInfoCopy.cellNumber) ? $scope.accountInfoCopy.cellNumber : null;
            accountHolder.emailAddress1 = ($scope.accountInfoCopy.emailAddress1) ? $scope.accountInfoCopy.emailAddress1 : null;
            accountHolder.fiscalCode_PSA = $scope.accountInfoCopy.fiscalCode_PSA; //PSA
            accountHolder.companyRegNum_PSA = $scope.accountInfoCopy.companyRegNum_PSA; // PSA
            accountHolder.organizationType_PSA = $scope.accountInfoCopy.organizationType_PSA; // PSA
            accountHolder.firstName = $scope.accountInfoCopy.firstName; // PSA
            accountHolder.lastName = $scope.accountInfoCopy.lastName; // PSA
            accountHolder.prefix = $scope.accountInfoCopy.prefix;
            accountHolder.email = $scope.accountInfoCopy.email;
            accountHolder.mobilePhone = $scope.accountInfoCopy.mobilePhone;
            accountHolder.sms = $scope.accountInfoCopy.sms;
            accountHolder.byPost = $scope.accountInfoCopy.byPost;
            // PSA accountHolder.ProducerCode = '';

            updatedAccount.accountHolder = accountHolder;
        }

        return updatedAccount;
    }

    /* Scope Functions*/
    ctrl.beginEditAccountContactDetails = () => {
        $scope.accountInfoCopy = angular.copy($scope.accountInfo);
        // PSA ctrl.replaceNullValues();
        $scope.isEditingContactDetails = true;
        $scope.accountInfoCopyView = ViewModelService.create($scope.accountInfoCopy, 'pc', 'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO');
        $scope.accountNumber = $scope.accountInfoCopyView.value.accountNumber;
        ctrl.findAccount($scope.accountNumber);
        ctrl.refreshOrganizationTypes_PSA();

        countryWatchPSA = $scope.$watch('accountInfoCopy.primaryAddress.country', () => {
            ctrl.refreshOrganizationTypes_PSA();

            // if ($stateParams.accountNumber && $stateParams.accountNumber.length > 0) {
            //     $scope.accountNumber = $stateParams.accountNumber;
            //     ctrl.findAccount($scope.accountNumber);
            // }
        });

    };

    ctrl.refreshOrganizationTypes_PSA = () => {
        $scope.organizationTypes_PSA = $scope.CountrySpecificPSA.orgTypesFor($scope.accountInfoCopy.primaryAddress.country);
    };

    ctrl.cancelEditAccountContactDetails = () => {
        $scope.isEditingContactDetails = false;
    };

    ctrl.replaceNullValues = () => {
        $scope.accountInfoCopy.homeNumber = $scope.accountInfoCopy.homeNumber || null;
        $scope.accountInfoCopy.workNumber = $scope.accountInfoCopy.workNumber || null;
        $scope.accountInfoCopy.cellNumber = $scope.accountInfoCopy.cellNumber || null;
        $scope.accountInfoCopy.emailAddress1 = $scope.accountInfoCopy.emailAddress1 || '';
        $scope.accountInfoCopy.primaryPhoneType = $scope.accountInfoCopy.primaryPhoneType || '';
        $scope.accountInfoCopy.primaryAddress.addressLine1 = $scope.accountInfoCopy.primaryAddress.addressLine1 || '';
        $scope.accountInfoCopy.primaryAddress.addressLine2 = $scope.accountInfoCopy.primaryAddress.addressLine2 || '';
        $scope.accountInfoCopy.primaryAddress.city = $scope.accountInfoCopy.primaryAddress.city || '';
        $scope.accountInfoCopy.primaryAddress.country = $scope.accountInfoCopy.primaryAddress.country || '';
        $scope.accountInfoCopy.primaryAddress.postalCode = $scope.accountInfoCopy.primaryAddress.postalCode || '';
        $scope.accountInfoCopy.primaryAddress.state = $scope.accountInfoCopy.primaryAddress.state || '';
    };

    ctrl.updateContactDetails = (contactDetailsForm) => {
        contactDetailsForm.submitted = true;

        if (contactDetailsForm.invalid) {
            return;
        }

        const updatedAccount = getUpdatedAccountContactDetails();
        if((updatedAccount.accountHolder.emailAddress1 == null && $scope.EmailAttempt == 0) ){
            $scope.emailValidation = $translate.instant('gateway.views.new-quote-account-search.ContactType.EmailValidation');
            $scope.EmailAttempt = 1;
            return ;
        }
        const updateContactDetailsPromise = AccountService.updateAccountDetails(updatedAccount);
        $scope.updateContactDetailsPromise = updateContactDetailsPromise;

        $q.when(updateContactDetailsPromise)
            .then($scope.mapAccountDetails)
            .then(() => {
                $scope.isEditingContactDetails = false;
            })
            .then(() => {
                ModalService.showInfo('gateway.views.account-detail.Saved Title', 'gateway.views.account-detail.Saved Message');
            })
            .then(() => {
                // refresh new organization type
                $scope.accountInfo.organizationTypeName_PSA = $scope.accountInfoCopy.organizationType_PSA ? $scope.accountInfoCopyView.organizationType_PSA.value.name : null; // PSA
                countryWatchPSA();
            })
            .catch(() => {
                ModalService.showError('gateway.views.account-detail.Save Failed Title', 'gateway.views.account-detail.Save Failed Message', '');
            });
    };

    ctrl.shouldShowContactPerson_PSA = () => {
        return $scope.accountInfo.prefix || $scope.accountInfo.firstName || $scope.accountInfo.lastName || $scope.accountInfo.emailAddress1;
    };

    // Check that the user has the permission to edit contact details
    ctrl.shouldShowEditContactButton = () => {
        const permissionDTO = {
            permission: 'editaccountsummary'
        };

        const permissionCheckPromise = UserService.hasUserSystemPermission(permissionDTO);

        permissionCheckPromise.then((showEditContact) => {
            $scope.showEditContactButton = showEditContact;
        });
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$translate','$state', '$q', '$filter', 'AccountService', 'UserService', 'ModalService', 'ViewModelService', 'CountrySpecificPSA'];

export default fn;
